class Lightbox {
  constructor() {
    this.images = [];
    this.current = 0;
    this.build();
    this.init();
  }

  build() {
    const el = document.createElement('div');
    el.id = 'lightbox';
    el.className = 'lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.innerHTML = `
      <div class="lightbox__overlay"></div>
      <button class="lightbox__close" aria-label="Close">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
      <button class="lightbox__nav lightbox__nav--prev" aria-label="Previous">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M12 4l-7 6 7 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="lightbox__stage">
        <img class="lightbox__img" src="" alt="">
      </div>
      <button class="lightbox__nav lightbox__nav--next" aria-label="Next">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M8 4l7 6-7 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <div class="lightbox__counter"></div>
    `;
    document.body.appendChild(el);

    this.modal   = el;
    this.img     = el.querySelector('.lightbox__img');
    this.counter = el.querySelector('.lightbox__counter');
    this.prevBtn = el.querySelector('.lightbox__nav--prev');
    this.nextBtn = el.querySelector('.lightbox__nav--next');
  }

  init() {
    document.addEventListener('click', e => {
      const trigger = e.target.closest('[data-lightbox-trigger]');
      if (!trigger) return;
      const images = JSON.parse(trigger.dataset.lightboxImages || '[]');
      if (!images.length) return;
      this.open(images, 0);
    });

    this.modal.querySelector('.lightbox__overlay').addEventListener('click', () => this.close());
    this.modal.querySelector('.lightbox__close').addEventListener('click', () => this.close());
    this.prevBtn.addEventListener('click', () => this.navigate(-1));
    this.nextBtn.addEventListener('click', () => this.navigate(1));

    document.addEventListener('keydown', e => {
      if (!this.modal.classList.contains('is-open')) return;
      if (e.key === 'Escape')     this.close();
      if (e.key === 'ArrowLeft')  this.navigate(-1);
      if (e.key === 'ArrowRight') this.navigate(1);
    });

    let startX = 0;
    this.modal.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    this.modal.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) this.navigate(dx < 0 ? 1 : -1);
    });
  }

  open(images, startIndex) {
    this.images  = images;
    this.current = startIndex;
    this.render();
    this.modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  navigate(dir) {
    this.current = (this.current + dir + this.images.length) % this.images.length;
    this.render();
  }

  render() {
    const { src, alt } = this.images[this.current];
    this.img.style.opacity = '0';
    this.img.src = src;
    this.img.alt = alt || '';
    this.img.onload = () => { this.img.style.opacity = '1'; };

    const multiple = this.images.length > 1;
    this.counter.textContent = multiple ? `${this.current + 1} / ${this.images.length}` : '';
    this.prevBtn.style.display = multiple ? '' : 'none';
    this.nextBtn.style.display = multiple ? '' : 'none';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new Lightbox());
} else {
  new Lightbox();
}
